import { Voni } from '../client';

export interface LogEntry {
  level: number;
  message: string;
  timestamp: string;
  context?: Record<string, unknown>;
  stack?: string;
}

export class LogsResource {
  constructor(private client: Voni) {}

  async create(entry: LogEntry): Promise<void> {
    await this.client.request('POST', '/logs', undefined, entry);
  }
}
